import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { JsonHttpService } from '../../http/json-http.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SecretService {
  private http = inject(JsonHttpService);

  getSecret(secretId: string): Promise<string> {
    const options = { params: new HttpParams().set('secretId', secretId) };
    return firstValueFrom(this.http.getWithErrorEval('/api/secrets/get-secret', options, err => err?.status !== 404));
  }
}
